"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

export default function ChatVisibilityController() {
  const pathname = usePathname();

  useEffect(() => {
    const shouldHideChat = pathname.includes("/campaign/") || pathname.includes("/suppliers");

    const chatButton = document.getElementById("embedded-messaging");
    if (chatButton) {
      chatButton.style.display = shouldHideChat ? "none" : "block";
      return;
    }

    const observer = new MutationObserver(() => {
      const chatButton = document.getElementById("embedded-messaging");
      if (chatButton) {
        chatButton.style.display = shouldHideChat ? "none" : "block";
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [pathname]);

  return null;
}
